/* Camada interativa da jennibag (o que o JS do tema dele fazia via elementos que nao copiamos). */
(function () {
  'use strict';
  // abas do produto (dbtfy-product-tab): o handler dele morava no <dbtfy-product-tab> do layout
  document.addEventListener('click', function (e) {
    var s = e.target.closest('.product-tab-details');
    if (!s || !s.closest('[class*="cl-sec-"], .cl-pdp')) return;
    var box = s.closest('.dbtfy-product-tabs') || document, id = s.getAttribute('data-id');
    var c = box.querySelector('.product-tab-content[data-id="' + id + '"]');
    box.querySelectorAll('.product-tab-content').forEach(function (o) { if (o !== c) o.classList.add('clx-hidden'); });
    box.querySelectorAll('.product-tab-details').forEach(function (o) { if (o !== s) o.classList.remove('product-tab-active'); });
    if (c) c.classList.toggle('clx-hidden');
    s.classList.toggle('product-tab-active');
  });

  // "Best Travel Bundle" (dbtfy upsell bundles dele): total, total com desconto e "SAVE" pelas
  // variantes escolhidas (data-price = preco da NOSSA variante, gravado no build)
  function fmt(c) {
    var f = (document.querySelector('[data-money]') || {}).getAttribute ? document.querySelector('[data-money]').getAttribute('data-money') : null;
    f = f || 'R$ {{amount_with_comma_separator}}';
    var n = (Math.round(c) / 100).toFixed(2).split('.');
    var a = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','), b = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return f.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, b + ',' + n[1]).replace(/\{\{\s*amount\s*\}\}/, a + '.' + n[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, a).replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, b);
  }
  function bundle(box) {
    var sum = 0;
    box.querySelectorAll('.dbtfy-upsell-bundles__item').forEach(function (it) {
      var cb = it.querySelector('.dbtfy-upsell-product-item__checkbox'), s = it.querySelector('select[name="id[]"]');
      if (!s || (cb && !cb.checked)) return;
      var o = s.options[s.selectedIndex]; sum += +(o && o.getAttribute('data-price')) || 0;
    });
    var d = +box.getAttribute('data-discount-amount') || 0, t = box.getAttribute('data-discount-type');
    var disc = t === '%' ? sum * (1 - d / 100) : Math.max(0, sum - d * 100);
    var op = box.querySelector('.dbtfy-upsell-bundles__original-price'), dp = box.querySelector('.dbtfy-upsell-bundles__discount-price'),
      sp = box.querySelector('.dbtfy-upsell-bundles__save-price');
    if (!sum) return;
    if (op) op.textContent = fmt(sum);
    if (dp) dp.textContent = fmt(disc);
    if (sp) {
      var badge = sp.querySelector('span');
      if (!badge) { badge = document.createElement('span'); badge.className = 'clx-badge dbtfy-sale-badge'; sp.appendChild(badge); }
      badge.textContent = 'SAVE ' + fmt(sum - disc);
    }
  }
  // Judge.me: o JS dele poe --small (<=600px) / --medium (<=768px) no widget conforme a LARGURA
  function jdgmSize() {
    document.querySelectorAll('[class*="cl-sec-"] .jdgm-review-widget').forEach(function (w) {
      var x = w.getBoundingClientRect().width;
      w.classList.toggle('jdgm-review-widget--small', x > 0 && x <= 600);
      w.classList.toggle('jdgm-review-widget--medium', x > 600 && x <= 768);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', jdgmSize); else jdgmSize();
  window.addEventListener('resize', jdgmSize);

  // Judge.me (o JS do app nao roda aqui): "Write a review" abre/fecha o formulario copiado
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[class*="cl-sec-"] .jdgm-write-rev-link');
    if (!a) return;
    e.preventDefault();
    var box = a.closest('.jdgm-rev-widg, .jdgm-widget') || a.closest('[class*="cl-sec-"]');
    var f = box && box.querySelector('.jdgm-form-wrapper'); if (!f) return;
    var open = f.style.display === 'none';
    f.style.display = open ? '' : 'none';
    a.textContent = open ? 'Cancel review' : 'Write a review';
    a.classList.toggle('close-form-btn', open);
    a.setAttribute('aria-expanded', String(open));
  });

  // estrelas do buybox ("See all reviews"): a secao Judge.me clonada saiu (retrabalho 10-15) -> rola ate a
  // secao do app de reviews do operador (aReviews)
  function toReviews(e) {
    var s = e.target.closest('[class*="cl-sec-"] .jdgm-prev-badge');
    if (!s || (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ')) return;
    var t = document.querySelector('.shopify-section[id*="areviews"]');
    if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  document.addEventListener('click', toReviews);
  document.addEventListener('keydown', toReviews);

  // "Estimated Delivery Date Plus" (app dele): datas a partir de HOJE no navegador, como o app
  // (Ordered = hoje; Order Ready = +2..+3; Delivered = +7..+13 dias corridos)
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function d(n) { var x = new Date(); x.setDate(x.getDate() + n); return MON[x.getMonth()] + ' ' + x.getDate(); }
  function setFirstText(el, txt) {
    if (!el) return;
    for (var i = 0; i < el.childNodes.length; i++) if (el.childNodes[i].nodeType === 3) { el.childNodes[i].nodeValue = txt; return; }
  }
  function bootDelivery() {
    document.querySelectorAll('.delivery-widget__theme').forEach(function (w) {
      setFirstText(w.querySelector('.date-left__sub-content > span'), d(0));
      setFirstText(w.querySelector('.date-center__sub-content > span'), d(2) + ' - ' + d(3));
      var r = w.querySelector('.date-right__sub-content > span');
      setFirstText(r, d(7) + ' - ' + d(13));
      var p = r && r.querySelector('p'); if (p) p.textContent = p.textContent.replace(/[A-Z][a-z]{2} \d+ - [A-Z][a-z]{2} \d+/, d(7) + ' - ' + d(13));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootDelivery); else bootDelivery();

  // Fracao de pixel do topo de cada secao = a da pagina dele (measure_fractions.py -> window.CL_FRAC,
  // chave = classe-marcador da pagina). Margem < 1px por secao; so quando a contagem de secoes visiveis
  // bate (sem o header, como no gate). Para o visitante (header presente) nada muda.
  function fracMatch() {
    var M = window.CL_FRAC; if (!M) return;
    var key = null;
    for (var k in M) if (document.querySelector('.' + k)) { key = k; break; }
    if (!key) return;
    var T = M[key][window.innerWidth >= 750 ? 'd' : 'm'];
    if (!T) return;
    var secs = [].filter.call(document.querySelectorAll('.shopify-section:not(.shopify-section .shopify-section)'),
      function (s) { return s.getBoundingClientRect().height >= 1; });
    if (secs.length !== T.length) {
      secs.forEach(function (s) { if (s.__clFrac != null) { s.style.marginTop = ''; s.__clFrac = null; } });
      return;
    }
    secs.forEach(function (s, i) {
      var pos = getComputedStyle(s).position;
      if (pos === 'fixed' || pos === 'absolute') return;
      if (s.__clFrac == null) s.__clFrac = parseFloat(getComputedStyle(s).marginTop) || 0;
      var t = s.getBoundingClientRect().top + window.scrollY, f = t - Math.floor(t);
      var d = ((T[i] - f) % 1 + 1) % 1;
      if (d < 0.005 || d > 0.995) return;
      var cur = parseFloat(s.style.marginTop) || s.__clFrac;
      var nxt = cur + d; if (nxt - s.__clFrac >= 1) nxt -= 1;
      s.style.marginTop = nxt.toFixed(3) + 'px';
    });
  }
  (function fracWatch() {
    var q = 0, run = function () { if (q) return; q = requestAnimationFrame(function () { q = 0; fracMatch(); }); };
    if (window.ResizeObserver) new ResizeObserver(run).observe(document.body);
    window.addEventListener('load', run);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  })();

  function bootBundles() { document.querySelectorAll('cl-dbtfy-upsell-bundles').forEach(bundle); }
  document.addEventListener('change', function (e) {
    var box = e.target.closest('cl-dbtfy-upsell-bundles'); if (box) bundle(box);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootBundles); else bootBundles();
})();
